import { RoadDetailInfo as L2RSegmentDetailInfo } from "@l2r-front/l2r-networks"
import {
    styled,
    styledForMobile,
    SIDEBAR_SPACING,
    SIDEBAR_SPACING_MOBILE,
} from "@l2r-front/l2r-ui"

import { DocumentList } from "../DocumentList"

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/gray_states/light"].main,
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    overflowY: "auto",
    padding: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE) : theme.spacing(5, SIDEBAR_SPACING, 0, SIDEBAR_SPACING),
}))

export const HeaderWrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: "white",
    padding: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE) : theme.spacing(5, SIDEBAR_SPACING, 8, SIDEBAR_SPACING),
    margin: isMobile ? theme.spacing(0, -SIDEBAR_SPACING_MOBILE, -SIDEBAR_SPACING_MOBILE, -SIDEBAR_SPACING_MOBILE) : theme.spacing(-5, -SIDEBAR_SPACING, 0, -SIDEBAR_SPACING),
}))

export const RoadDetailInfo = styled(L2RSegmentDetailInfo)(() => ({
    margin: 0,
}))

export const List = styled(DocumentList)(({ theme }) => ({
    flex: "1 1 auto",
    marginTop: theme.spacing(8),
}))

export const PaginationContainer = styledForMobile("div", ["position"])(({ isMobile, position, theme }) => ({
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette["common/gray_states/light"].main,
    position: position,
    bottom: 0,
    paddingTop: theme.spacing(5),
    paddingBottom: isMobile ? theme.spacing(SIDEBAR_SPACING_MOBILE) : theme.spacing(5),
    margin: isMobile ? theme.spacing(0, -SIDEBAR_SPACING_MOBILE, 0, -SIDEBAR_SPACING_MOBILE) : theme.spacing(0, -SIDEBAR_SPACING, 0, -SIDEBAR_SPACING),
}))